import { Grid } from "@mui/material";
import { Formik, Form } from "formik";
import { FC } from "react";
import useLocales from "../../../hooks/useLocales";
import { customerFilterInitials } from "../../../interfaces/Customer";
import { ApplyFilterButton, ClearButton, TextInput } from "../../../components";
import { clean } from "../../../utils";

interface IListFilter {
  onSubmit: Function;
}

const CustomerListFilter: FC<IListFilter> = ({ onSubmit }) => {
  const { translate } = useLocales();

  function submitHandler(values: any): void {
    let cleanedValues = clean({
      ...values,
    });

    onSubmit((prev: any) => ({
      ...prev,
      params: {
        ...prev.params,
        filter: {
          ...prev.params.filter,
          ...cleanedValues,
        },
      },
    }));
  }

  return (
    <Formik initialValues={customerFilterInitials} onSubmit={submitHandler}>
      {(props) => (
        <Form>
          <Grid
            container
            spacing={3}
            sx={{ marginTop: 2, marginBottom: "40px" }}
          >
            <Grid item md={3}>
              <TextInput name="customerCode" label="Müşteri Kodu" />
            </Grid>

            <Grid item md={3}>
              <TextInput
                name="title"
                label={translate("resources.customers.name")}
              />
            </Grid>

            <Grid item md={3}>
              <TextInput
                name="citizenOrTaxNumber"
                label={translate("resources.customers.tcknVkn")}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} justifyContent="flex-end">
            <Grid item>
              <ClearButton
                onSubmit={onSubmit}
                defaultFilter={{
                  customerFilterTypeEnum: 2,
                  isDeleted: false,
                }}
              />
            </Grid>
            <Grid item>
              <ApplyFilterButton disable={false} />
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default CustomerListFilter;
